<template>
    <b-modal hide-footer
             size="lg"
             title="Fabricante"
             scrollable
             centered
             hide-header-close
             no-close-on-esc
             no-close-on-backdrop
             v-model="modal_manufacturer.show"
    >
        <b-form method="POST"
                data-vv-scope="modal_manufacturer"
                @submit.prevent="validateForm()"
        >
            <b-row>
                <b-col sm="6">
                    <b-form-group>
                        <label>
                            Nombre
                            <span class="text-danger">(*)</span>
                        </label>
                        <b-form-input id="nombre"
                                      name="nombre"
                                      v-model="manufacturer.nombre"
                                      data-vv-as=" "
                                      v-validate="'required|min:3|max:255'"
                        />
                        <span class="text-danger span-error small">
                            {{ errors.first('modal_manufacturer.nombre') }}
                        </span>
                    </b-form-group>
                </b-col>

                <b-col sm="6">
                    <b-form-group>
                        <label>
                            Dirección
                            <span class="text-danger">(*)</span>
                        </label>
                        <b-form-input id="direccion"
                                      name="direccion"
                                      v-model="manufacturer.direccion"
                                      data-vv-as=" "
                                      v-validate="'required|min:3|max:150'"
                        />
                        <span class="text-danger span-error small">
                            {{ errors.first('modal_manufacturer.direccion') }}
                        </span>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4">
                    <b-form-group>
                        <label>
                            Teléfono
                            <span class="text-danger">(*)</span>
                        </label>
                        <b-form-input id="telefono"
                                      name="telefono"
                                      v-model="manufacturer.telefono"
                                      data-vv-as=" "
                                      v-validate="'required|min:3|max:30'"
                        />
                        <span class="text-danger span-error small">
                            {{ errors.first('modal_manufacturer.telefono') }}
                        </span>
                    </b-form-group>
                </b-col>

                <b-col sm="4">
                    <b-form-group>
                        <label>
                            Tel de emergencia
                            <span class="text-danger">(*)</span>
                        </label>
                        <b-form-input id="telefono_de_emergencia"
                                      name="telefono_de_emergencia"
                                      data-vv-as=" "
                                      v-model="manufacturer.telefono_de_emergencia"
                                      v-validate="'required|min:3|max:30'"
                        />
                        <span class="text-danger span-error small">
                            {{ errors.first('modal_manufacturer.telefono_de_emergencia') }}
                        </span>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12"
                       class="row justify-content-center"
                >
                    <b-button @click="validateForm()"
                              size="sm"
                              variant="primary"
                              class="mx-1"
                    >
                        <i class="fa fa-floppy-o fa-lg"></i> Guardar
                    </b-button>

                    <b-button @click="closeModal()"
                              size="sm"
                              variant="secondary"
                              class="mx-1"
                    >
                        <i class="fa fa-close"></i> Cancelar
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal_manufacturer',
    methods: {
        ...mapActions('productsCalculator', ['createManufacturer']),
        ...mapMutations('productsCalculator', [
            'setShowToModalManufacturer',
            'setManufacturerToProduct',
            'setShowToModal'
        ]),
        async validateForm() {
            await this.$validator.validateAll('modal_manufacturer')
                .then(async (result) => {
                    if (result) {
                        await this.createManufacturer();

                        this.setShowToModalManufacturer(false);
                        this.setShowToModal(true);
                        this.$emit('createManufacturer')
                    }
                });
        },
        closeModal() {
            this.setShowToModalManufacturer(false);
            this.setShowToModal(true);
        }
    },
    computed: {
        ...mapState('productsCalculator', ['manufacturer']),
        ...mapState('productsCalculator', ['modal_manufacturer']),
    },
};
</script>
